import request from '@/utils/request'

export function selectSuperSet(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/superSet/selectSuperSet?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}
export function addSuperSet(data) {
    return request({
        url: `api/serviceCenter/superSet/addSuperSet`,
        method: 'post',
        data,
    })
}

export function upDateSuperSet(data) {
    return request({
        url: `api/serviceCenter/superSet/upDateSuperSet`,
        method: 'post',
        data,
    })
}

export function bathDeleteSuperSet(data) {
    return request({
        url: `api/serviceCenter/superSet/bathDeleteSuperSet`,
        method: 'post',
        data,
    })
}







